<div class="d-flex flex-column px-5 mb-4">
  <h2>DTCM event form</h2>
  <h5 class="text-hint">Please fill in the DTCM required data for the event.</h5>
  <div class="d-flex flex-column justify-content-around">
    @if (isLoading) {
    <ngx-loading-dialog></ngx-loading-dialog>
    } @else {
    <div class="row mb-3 align-items-baseline">
      <div class="col d-flex justify-content-end p-0 pl-3 pr-3">
        <button *ngIf="eventCompleted" class="btn btn-primary align-self-end" type="submit" (click)="openReport()" nbTooltip="Open the DTCM report">
          <i class="fas fa-file-alt"></i> DTCM report
        </button>
        <span nbTooltip="Please come back as soon as the event finishes to view the report">
          <button *ngIf="!eventCompleted" class="btn btn-primary align-self-end" type="submit" disabled><i class="fas fa-file-alt"></i> DTCM report</button>
        </span>
      </div>
    </div>
    @if (form) {
    <div [formGroup]="form" class="row mb-4 align-items-baseline justify-content-start">
      <div class="d-flex dtcmForm">
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column position-relative">
            <nb-form-field class="px-0 mw-100">
              <input
                type="text"
                nbInput
                fullWidth
                class="det-input"
                shape="rectangle"
                [status]="form.get('eventCode').touched ? (form.get('eventCode').errors ? 'danger' : 'primary') : 'basic'"
                formControlName="eventCode"
                placeholder="Enter DET Performance Code"
                required
              />
            </nb-form-field>
            <span *ngIf="form.get('eventCode').touched && form.get('eventCode')?.errors?.required" class="text-danger position-absolute top-0 error-message">
              This field is required
            </span>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column position-relative">
            <nb-form-field class="px-0 mw-100 flex flex-column">
              <input
                type="email"
                [status]="form.get('email').touched ? (form.get('email').errors ? 'danger' : 'primary') : 'basic'"
                nbInput
                fullWidth
                class="det-input"
                shape="rectangle"
                formControlName="email"
                (blur)="trimFromControlValue('email')"
                placeholder="Enter ticket manager's email"
                required
              />
            </nb-form-field>
            <span *ngIf="form.get('email').touched && form.get('email')?.errors" class="text-danger position-absolute top-0 error-message">
              {{ form.get('email')?.errors?.required ? 'This field is required' : 'Invalid email' }}
            </span>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column position-relative permit-no">
            <nb-form-field class="px-0 mw-100">
              <input
                type="text"
                nbInput
                fullWidth
                class="det-input"
                shape="rectangle"
                formControlName="permitNo"
                placeholder="Enter the DET-issued Permit Number"
                [status]="form.get('permitNo').touched ? (form.get('permitNo').errors ? 'danger' : 'primary') : 'basic'"
                (blur)="trimFromControlValue('permitNo')"
                required
              />
            </nb-form-field>
            <span *ngIf="form.get('permitNo').touched && form.get('permitNo')?.errors?.required" class="text-danger position-absolute top-0 error-message">
              This field is required
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end p-0 pl-3 pr-3 align-self-end">
        <button class="btn btn-primary align-self-end" [disabled]="form.invalid" type="submit" (click)="getDtcmDetails()">
          <i class="fas fa-file-alt"></i> Submit DET Performance Code
        </button>
      </div>
    </div>
    <ng-container *ngIf="sections">
      <ng-template ngFor let-persona [ngForOf]="personas">
        <ngx-dtcm-section
          class="bg-white border rounded mb-3"
          [event]="event"
          [persona]="persona"
          [personas]="personas"
          [sections]="sections"
          [dtcm]="persona.options?.dtcm"
          [eventCode]="form.value.eventCode"
          [email]="form.controls.email"
          [permitNo]="form.value.permitNo"
        >
        </ngx-dtcm-section>
      </ng-template>
    </ng-container>
    <ng-template #container></ng-template>
    <div class="d-flex flex-row justify-content-between my-3">
      <button [disabled]="isAddSectionDisabled" class="btn btn-primary align-self-end" type="submit" (click)="addSection()"><i class="fas fa-plus"></i> Add section</button>
    </div>
    }
    }
  </div>
</div>
